// 服务通知类型集合
export const ServiceSubscribeTypes = new Map([['after_sales', '维修服务进度']])
